import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IMAGES } from '../config/constants';

const InstitutionalCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
  };

  const cards = [
    {
      image: IMAGES.INSTITUTIONAL_TEAM,
      title: "Conocé a Nuestro Equipo",
      description: "Profesionales dedicados a la seguridad de tu industria, con más de 15 años ofreciendo soluciones a todas las industrias",
      subtitle: "Experiencia demostrada"
    },
    {
      image: IMAGES.INSTITUTIONAL_WAREHOUSE,
      title: "Depósito moderno",
      description: "Amplio stock de productos para todas las industrias",
      subtitle: "Stock permanente"
    },
    {
      image: IMAGES.INSTITUTIONAL_OFFICE,
      title: "Estamos para ayudarte",
      description: "Un equipo humano que te escucha, te asesora y te acompaña en cada decisión de seguridad",
      subtitle: "Atención personalizada"
    },
    {
      image: IMAGES.INSTITUTIONAL_WAREHOUSE,
      title: "Logística Integral",
      description: "Entrega rápida y segura en todo el AMBA. Tu pedido llega cuando lo necesitás, donde lo necesitás",
      subtitle: "Entrega en AMBA"
    },
    {
      image: IMAGES.INSTITUTIONAL_OFFICE,
      title: "Atención Exclusiva Empresas",
      description: "Asesoramiento especializado y condiciones preferenciales para grandes volúmenes y proyectos corporativos",
      subtitle: "Soluciones corporativas"
    },
    {
      image: IMAGES.INSTITUTIONAL_TEAM,
      title: "Seguridad e Higiene",
      description: "Te ofrecemos asesoramiento técnico y profesional para que tu empresa cumpla con todas las normativas nacionales e internacionales.",
      subtitle: "Asesoramiento técnico"
    }
  ];

  // Agrupar cards de a 3 para cada slide
  const slides = [];
  for (let i = 0; i < cards.length; i += 3) {
    slides.push(cards.slice(i, i + 3));
  }

  return (
    <section className="w-full bg-gradient-to-b from-slate-50 to-white py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            ¡Conocenos!
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Más que proveedores, somos tu equipo de confianza en seguridad industrial
          </p>
        </div>
        
        <Slider {...settings} className="institutional-slider">
          {slides.map((slideCards, slideIndex) => (
            <div key={slideIndex} className="px-4">
              <div className="flex justify-center items-start">
                <div className="flex flex-wrap justify-center gap-6 max-w-none">
                  {slideCards.map((card, cardIndex) => (
                    <div key={cardIndex} className="bg-white rounded-2xl shadow-lg overflow-hidden w-80 flex-shrink-0">
                      <div className="flex flex-col h-full">
                        {/* Imagen */}
                        <div className="w-full h-48 relative overflow-hidden">
                          <img
                            src={card.image}
                            alt={card.title}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.currentTarget.src = '/images/placeholder-institutional.jpg';
                            }}
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                        </div>
                        
                        {/* Contenido */}
                        <div className="p-6 flex-grow">
                          <span className="inline-block bg-orange-100 text-orange-600 text-sm font-semibold px-3 py-1 rounded-full mb-3">
                            {card.subtitle}
                          </span>
                          <h3 className="text-xl font-bold text-gray-800 mb-3 leading-tight">
                            {card.title}
                          </h3>
                          <p className="text-gray-600 leading-relaxed">
                            {card.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default InstitutionalCarousel;


